import { render, staticRenderFns } from "./NavigationContextOpen.vue?vue&type=template&id=649f163e&scoped=true"
import script from "./NavigationContextOpen.vue?vue&type=script&lang=js"
export * from "./NavigationContextOpen.vue?vue&type=script&lang=js"
import style0 from "./NavigationContextOpen.vue?vue&type=style&index=0&id=649f163e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649f163e",
  null
  
)

export default component.exports